import {
    convertMapToList,
    DEFAULT_STATUS_KEY,
    StatusInfo,
} from 'src/components/EntityStatusInfo/EntityStatusInfo';
import { CssColors } from 'src/styles/CssVariables';

export const ApplicationStatusInfoMap: Record<string, StatusInfo> = {
    ON_KYC: {
        color: CssColors.mainGray,
        borderColor: CssColors.mainGray,
        title: 'On KYC',
        backgroundColor: CssColors.mainGray,
    },
    VERIFICATION: {
        color: CssColors.mainGray,
        borderColor: CssColors.mainGray,
        title: 'Verification',
        backgroundColor: CssColors.mainGray,
    },
    UPDATE_REQUESTED: {
        color: CssColors.mainGray,
        borderColor: CssColors.mainGray,
        title: CssColors.mainGray,
        backgroundColor: CssColors.mainGray,
    },
    UNDERWRITING: {
        color: CssColors.mainGray,
        borderColor: CssColors.mainGray,
        title: 'Underwriting',
        backgroundColor: CssColors.mainGray,
    },
    DECLINED: {
        color: CssColors.mainRed,
        borderColor: CssColors.mainRed,
        title: 'Declined',
        backgroundColor: CssColors.mainRed,
    },
    CANCELED: {
        color: CssColors.mainRed,
        borderColor: CssColors.mainRed,
        title: 'Canceled',
        backgroundColor: CssColors.mainRed,
    },
    ACCOUNT_VERIFICATION: {
        color: CssColors.mainGray,
        borderColor: CssColors.mainGray,
        title: 'Acoount verification',
        backgroundColor: CssColors.mainGray,
    },
    ERROR: {
        title: 'Error',
        color: CssColors.mainRed,
        borderColor: CssColors.mainRed,
        backgroundColor: CssColors.mainRed,
    },
    ADVANCE_CONSENT_CONFIRMATION: {
        title: 'Advance consent confirmation',
        color: CssColors.mainGray,
        borderColor: CssColors.mainGray,
        backgroundColor: CssColors.mainGray,
    },
    AWAITING_ADVANCE_PAYMENT: {
        title: 'Awaiting advance payment',
        color: CssColors.mainGray,
        borderColor: CssColors.mainGray,
        backgroundColor: CssColors.mainGray,
    },
    ADVANCE_CONSENT_EXPIRED: {
        title: 'Advance consent expired',
        color: CssColors.mainRed,
        borderColor: CssColors.mainRed,
        backgroundColor: CssColors.mainRed,
    },
    DENTAL_TREATMENT_STARTED: {
        title: 'Dental treatment started',
        color: CssColors.mainGreen,
        borderColor: CssColors.mainGreen,
        backgroundColor: CssColors.mainGreen,
    },
    '1ST_STAGE_COMPLETED': {
        title: '1st stage completed',
        color: CssColors.mainGreen,
        borderColor: CssColors.mainGreen,
        backgroundColor: CssColors.mainGreen,
    },
    [DEFAULT_STATUS_KEY]: {
        color: '#91796c',
        borderColor: '#F4F0DF',
        title: '',
        backgroundColor: '#F4F0DF',
    },
};

export const getApplicationStatuses = () => {
    return convertMapToList(ApplicationStatusInfoMap);
};
